import { createCodeBlockWriter } from '../../util/data-util.js'
import { ServiceProvider } from '../service-provider.js'
import { ServiceProviderVersion } from '../service-provider-version.js'

export function calculateServiceProviderTsDeclarations(
	bo: ServiceProvider,
	mustSatisfyProviderVersions: string[],
): string[] {
	const availableMethods = bo.methods.filter((m) =>
		mustSatisfyProviderVersions.every((v) => m.availableInVersions.includes(v)),
	)
	const writer = createCodeBlockWriter()

	writer.write(`export class ${bo.boId}`).block(() => {
		availableMethods.forEach((m) => {
			writer.writeLine(
				`static async ${m.name}(${m.parameters.map((p) => `${p.name}: ${p.type}`).join(', ')}): Promise<${m.getTsReturnType()}>`,
			)
		})
	})

	return [writer.toString()]
}
